// extracted by mini-css-extract-plugin
module.exports = {"disc":"e_xm","accent":"e_ym","empty":"e_zm","s32":"e_Am","s36":"e_Bm","s44":"e_Cm","s56":"e_Dm","s72":"e_Em"};